/* eslint max-len: ["error", 300] */

import dashboardService from '../../services/dashboard';
import ENV from '../../services/env';

const types = {
  ALL_CAMPAIGN_URLS: 'dashboardService/allCampaignUrls',
  CLEAR_ALL_CAMPAIGN_URLS: 'dashboardService/clearAllCampaignUrls',
  
  CHANGE_CHARTS_URLS: 'dashboardService/changeChartsUrls',
  CLEAR_ALL_SUMMARY: 'dashboardService/clearAllSummary',

  GET_CAMPAIGN_SUMMARY: 'dashboardService/getCampaignSummary',
  GET_DESKTOP_SUMMARY: 'dashboardService/getDesktopSummary',
  GET_MOBILE_SUMMARY: 'dashboardService/getMobileSummary',

  GET_ALL_DASHBOARD_VIDEOS: 'dashboardService/getAllDashboardVideos',
  GET_DASHBOARD_VIDEO_DETAIL: 'dashboardService/getDashboardVideoDetail',
};

const state = {
  allChartUrls: null,
  campaignUrls: null,
  allDashboardVideos: [],

  campaignSummary: null,
  desktopSummary: null,
  mobileSummary: null,

  dashboardVideoDetail: null,
};

const getters = {
  getCampaignSummary: s => s.campaignSummary,
  getDesktopSummary: s => s.desktopSummary,
  getMobileSummary: s => s.mobileSummary,

  getAllChartUrls: s => s.allChartUrls,
  getCampaignUrls: s => s.campaignUrls,

  getAllDashboardVideosWithAgency: s => s.allDashboardVideos.filter(v => v.agency.id !== null),
  getAllDashboardVideos: s => s.allDashboardVideos,
  getDashboardVideoDetail: s => s.dashboardVideoDetail,
};

const actions = {
  actionClearCampaignUrls({ commit }) {
    commit(types.CLEAR_ALL_CAMPAIGN_URLS);
  },
  actionClearAllSummary({ commit }) {
    commit(types.CLEAR_ALL_SUMMARY);
  },
  actionGetAllDashboardVideos({ commit }, agencyId) {
    dashboardService
    .getUserDashboardVideos(agencyId)
    .then((res) => {

      const {
        _data,
      } = res;

      commit(types.GET_ALL_DASHBOARD_VIDEOS, _data);

      // 預設先拿第一筆
      if (_data.length !== 0) {
        const videoId = _data[0].video_id;

        commit(types.CHANGE_CHARTS_URLS, videoId);
  
        // Detail
        dashboardService
        .getUserDashboardVideosDetail({
          videoId, 
          agencyId,
        })
        .then((result) => {
          const {
            detailData,
          } = result;
  
          commit(types.GET_DASHBOARD_VIDEO_DETAIL, detailData);
        })
        .catch(() => {
          // commit(rootypes.isShowRootLoading);
        });
      } else {
        commit(types.GET_DASHBOARD_VIDEO_DETAIL, null);
      }
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });

  },

  actionGetDashboardVideoDetail({ commit }, data) {

    const {
      videoId,
    } = data;

    dashboardService
    .getUserDashboardVideosDetail(data)
    .then((res) => {

      const {
        detailData,
      } = res;

      commit(types.GET_DASHBOARD_VIDEO_DETAIL, detailData);
      commit(types.CHANGE_CHARTS_URLS, videoId);

    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });

  },

  actionGetDesktopSummary({ commit }, urlData) {

    dashboardService
    .getDashboardDesktopSummary(urlData)
    .then((res) => {

      const {
        data,
      } = res;

      commit(types.GET_DESKTOP_SUMMARY, data);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });

  },

  actionGetMobileSummary({ commit }, urlData) {

    dashboardService
    .getDashboardMobileSummary(urlData)
    .then((res) => {

      const {
        data,
      } = res;

      commit(types.GET_MOBILE_SUMMARY, data);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });

  },

  actionGetCampaignUrls({ commit }, urlData) {
    commit(types.ALL_CAMPAIGN_URLS, urlData);
  },

};

// mutations
const mutations = {
  // Campaign insight
  [types.ALL_CAMPAIGN_URLS](s, urlData) {

    const {
      id,
      type,
      clientId,
    } = urlData;

    switch (type) {
      case 'speed': 
        s.campaignUrls = {
          dailyViewMultipleSeriesData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/daily_view_multiple_series?type=${type}&client_id=${clientId}` },
          dailyImpressionMultipleSeriesData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/daily_impression_multiple_series?type=${type}&client_id=${clientId}` },
          dailyQuartileMultipleRangeAndLineData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/daily_quartile_basic_area?type=${type}&client_id=${clientId}` },
          dailyReachArea: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/daily_reach_area?type=${type}&client_id=${clientId}` },
          deviceDonutChartData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/device_donut_chart?type=${type}&client_id=${clientId}` },
          interestPieChartData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/interest_pie_chart?type=${type}&client_id=${clientId}` },
          demographicsPieChartData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/demographics_pie_chart?type=${type}&client_id=${clientId}` },
          dailyInteractionMultipleSeriesData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/daily_interaction_multiple_series?type=${type}&client_id=${clientId}` },
          genderPieChartData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/gender_pie_chart?type=${type}&client_id=${clientId}` },
        };    
        break;

      case 'direct':
        s.campaignUrls = {
          // 1. 觀看四階 
          dailyQuartileMultipleRangeAndLineData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/daily_quartile_basic_area?type=${type}&client_id=${clientId}` },
          // 2. 1 + reach
          dailyReachArea: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/daily_reach_area?type=${type}&client_id=${clientId}` },
          // 3. 裝置 
          deviceDonutChartData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/device_donut_chart?type=${type}&client_id=${clientId}` },
          // 4. 媒體聲量
          dailySovMultipleSeriesData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${id}/graphs/daily_sov_multiple_series?type=${type}&client_id=${clientId}` },
        };  
        break;
      default:
    }

  },
  [types.CHANGE_CHARTS_URLS](s) {

    s.allChartUrls = {

      // Media insight
      hourReachSplineData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/graphs/hourly_device_reach_spline` },
      dailyReachSplineData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/graphs/daily_device_reach_spline` },
      quartileViewRateData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/graphs/quartile_view_rate_table` },
      interactionRateBasicColumnData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/graphs/interaction_rate_basic_column` },

      // Media insight - Reach
      deviceReachDonutChartDataZero: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/0/graphs/device_reach_donut_chart` },
      deviceReachDonutChartDataOne: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/1/graphs/device_reach_donut_chart` },
      deviceReachDonutChartDataTwo: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/2/graphs/device_reach_donut_chart` },
      deviceReachDonutChartDataThree: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/3/graphs/device_reach_donut_chart` },

      interestReachBasicColumnDataZero: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/0/graphs/interest_reach_basic_column` },
      interestReachBasicColumnDataOne: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/1/graphs/interest_reach_basic_column` },
      interestReachBasicColumnDataTwo: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/2/graphs/interest_reach_basic_column` },
      interestReachBasicColumnDataThree: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/media/3/graphs/interest_reach_basic_column` },

      // Audience insight
      lastMonthInterestReachBasicColumnData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/audience/graphs/last_month_interest_reach_basic_column` },
      lastMonthDeviceReachBasicColumnData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/audience/graphs/last_month_device_reach_basic_column` },

      hourlyReachSplineAudienceData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/audience/graphs/hourly_reach_spline` },
      dailyReachSplineAudienceData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/audience/graphs/daily_reach_spline` },

      lastMonthInterestQuartileViewRateStackedColumnData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/audience/graphs/last_month_interest_quartile_view_rate_fixed_placement_columns` },
      lastMonthDeviceQuartileViewRateStackedColumnData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/audience/graphs/last_month_device_quartile_view_rate_fixed_placement_columns` },

      lastMonthInterestInteractionRateBasicColumnData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/audience/graphs/last_month_interest_interaction_rate_basic_column` },
      lastMonthDeviceInteractionRateBasicColumnData: { url: `${ENV.ERP_PORT}/api/v1/bm/dashboard/audience/graphs/last_month_device_interaction_rate_basic_column` },
    };
  },
  [types.GET_ALL_DASHBOARD_VIDEOS](s, d) {
    s.allDashboardVideos = d;
  },
  [types.GET_CAMPAIGN_SUMMARY](s, d) {
    s.campaignSummary = d;
  },
  [types.GET_DESKTOP_SUMMARY](s, d) {
    s.desktopSummary = d;
  },
  [types.GET_MOBILE_SUMMARY](s, d) {
    s.mobileSummary = d;
  },
  [types.GET_DASHBOARD_VIDEO_DETAIL](s, d) {
    s.dashboardVideoDetail = d;
  },
  [types.CLEAR_ALL_SUMMARY](s) {
    s.desktopSummary = null;
    s.mobileSummary = null;
  },
  [types.CLEAR_ALL_CAMPAIGN_URLS](s) {
    s.campaignUrls = null;
  },
};

/*
  因為我們把 vuex 所有職權都寫在同一隻檔案，
  所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js